import { SearchInputFilter } from './SearchInputFilter';
import { SelectFilter } from './SelectFilter';
import { DateRangeFilter } from './DateRangeFilter';
import { AmountFilter } from './AmountFilter';
import {
  INPUT_TYPE_AMOUNT,
  INPUT_TYPE_DATE,
  INPUT_TYPE_DATE_RANGE,
  INPUT_TYPE_SEARCH,
  INPUT_TYPE_SELECT
} from '../../helpers/helpers';
import { CardBody, Col, Row } from 'reactstrap';
import { DateFilter } from './DateFilter';

export const RenderFilters = ({
  filterInputs,
  searchParams,
  setSearchParams,
  colLg,
  colMd,
  colSm,
  noPagination = false,
  hasTime = false,
  hasDirectorInfo = false,
  initialParams
}: {
  filterInputs: object[];
  searchParams: URLSearchParams;
  setSearchParams: any;
  colLg?: number;
  colMd?: number;
  colSm?: number;
  noPagination?: boolean;
  hasTime?: boolean;
  hasDirectorInfo?: boolean;
  initialParams?: any;
}) => {
  return (
    <CardBody className='border border-dashed border-end-0 border-start-0'>
      <Row>
        {filterInputs.map(({ type, options, param, placeholder }: any, i) => {
          if (type === INPUT_TYPE_SEARCH) {
            return (
              <Col lg={colLg || 3} md={colMd || 3} sm={colSm || 4} key={i}>
                <SearchInputFilter
                  param={param}
                  searchParams={searchParams}
                  setSearchParams={setSearchParams}
                  placeholder={placeholder}
                />
              </Col>
            );
          }

          if (type === INPUT_TYPE_SELECT) {
            return (
              <Col lg={colLg || 3} md={colMd || 3} sm={colSm || 4} key={i}>
                <SelectFilter
                  param={param}
                  searchParams={searchParams}
                  setSearchParams={setSearchParams}
                  options={options}
                  placeholder={placeholder}
                  hasPagination={!noPagination}
                />
              </Col>
            );
          }

          if (type === INPUT_TYPE_DATE_RANGE) {
            return (
              <Col lg={colLg || 3} md={colMd || 3} sm={colSm || 4} key={i}>
                <DateRangeFilter
                  param={param}
                  searchParams={searchParams}
                  setSearchParams={setSearchParams}
                  noPagination={noPagination}
                  hasTime={hasTime}
                  hasDirectorInfo={hasDirectorInfo}
                />
              </Col>
            );
          }

          if (type === INPUT_TYPE_DATE) {
            return (
              <Col lg={colLg || 3} md={colMd || 3} sm={colSm || 4} key={i}>
                <DateFilter
                  searchParams={searchParams}
                  setSearchParams={setSearchParams}
                  noPagination={noPagination}
                  hasTime={hasTime}
                  param={param}
                  placeholder={placeholder}
                  hasDirectorInfo={hasDirectorInfo}
                />
              </Col>
            );
          }

          if (type === INPUT_TYPE_AMOUNT) {
            return (
              <Col lg={colLg || 3} md={colMd || 3} sm={colSm || 4} key={i}>
                <AmountFilter
                  param={param}
                  searchParams={searchParams}
                  setSearchParams={setSearchParams}
                  placeholder={placeholder}
                />
              </Col>
            );
          }
        })}
      </Row>
    </CardBody>
  );
};
